import { Text } from 'fitify-ui-landing/src/components/Text'
import { useTranslation } from 'next-i18next'

import {
  StyledDocumentContainer,
  StyledDocumentPageWrapper,
} from './Document.Styled'

interface ContactUsProps {
  title: string
  support: string
  socials: string
  companyName: string
  companyAddress: string
  vat: string
  registered: string
}

const Contact = ({
  title,
  support,
  socials,
  companyName,
  companyAddress,
  vat,
  registered,
}: ContactUsProps) => {
  const { t } = useTranslation()

  return (
    <StyledDocumentPageWrapper>
      <StyledDocumentContainer>
        <Text as={'h1'} variant={'feature-title'}>
          {t(title)}
        </Text>

        <Text
          as={'p'}
          html={t(support, {
            0: 'mailto:support@gofitify.com',
          })}
        />
        <Text
          as={'p'}
          html={t(socials, {
            0: 'https://www.facebook.com/fitifyapp',
            1: 'https://x.com/FitifyApps',
          })}
        />

        <Text as="h4">{t(companyName)}</Text>

        <Text as={'p'} html={t(companyAddress)} />

        <Text as={'p'} html={t(vat)} />

        <Text as={'p'} html={t(registered)} style={{ fontStyle: 'italic' }} />
      </StyledDocumentContainer>
    </StyledDocumentPageWrapper>
  )
}

export default Contact
